import { apiClient } from "./axios";

/** Envelope de listagem paginada do crm-api (`{ Items, NextCursor, Count }`), por cursor keyset. */
export interface CursorPage<T> {
  items: T[];
  nextCursor: string | null;
  count: number;
}

/**
 * Busca TODAS as páginas de um endpoint paginado por cursor e devolve a lista
 * achatada — mantém a paginação/filtragem client-side existente funcionando no
 * modo real. O crm-api pagina por keyset (`?cursor=<id>&limit=`, `OrderBy(Id)`),
 * devolvendo `nextCursor` enquanto houver mais; sem isso, o front pegava só a 1ª
 * página (default `limit=50`) e truncava listas grandes silenciosamente.
 *
 * Pede `limit=200` (máximo do backend) p/ reduzir round-trips. Guarda contra loop
 * infinito: para em `nextCursor` nulo, página vazia, ou cursor repetido.
 */
export async function fetchAllPaged<T>(
  path: string,
  params: Record<string, unknown> = {},
): Promise<T[]> {
  const out: T[] = [];
  const seen = new Set<string>();
  let cursor: string | undefined;

  for (;;) {
    const { data } = await apiClient.get<CursorPage<T>>(path, {
      params: { ...params, cursor, limit: 200 },
    });
    out.push(...data.items);

    const next = data.nextCursor;
    if (!next || data.items.length === 0 || seen.has(next)) break;
    seen.add(next);
    cursor = next;
  }

  return out;
}
